import React from 'react';
import './announcement-form-heading.scss';

interface AnnouncementFormHeadingProps {
  children: React.ReactNode;
}

const AnnouncementFormHeading = ({
  children,
}: AnnouncementFormHeadingProps) => (
  <div className="announcement-form-heading">{children}</div>
);

export default AnnouncementFormHeading;
